module.exports = __webpack_public_path__ + "static/media/Gloves.804855d5.jpg";